// It's not possible to use a transformRequest/transformResponse
// for query parameters. Let's put that in a dedicated file
// TODO: clean that up (MCC-2650)
import { getDefaultLocaleFromCountry } from '@core/helpers/countries'
import { getLink } from '@router/links'

import { ALERTS, GRADES, STOCK } from './Listings.constants'

const GRADES_TO_API = {
  [GRADES.SHINY]: 0,
  [GRADES.GOLD]: 1,
  [GRADES.SILVER]: 2,
  [GRADES.BRONZE]: 3,
  [GRADES.STALLONE]: 4,
}

export function toAPIFilters({
  title,
  sku,
  backmarketId,
  grade,
  buybox,
  stock,
  alert,
  market,
}) {
  const filters = { title, sku, buybox }

  if (backmarketId) {
    filters.product_id = backmarketId
  }

  if (grade) {
    filters.state = GRADES_TO_API[grade]
  }

  if (market) {
    // The listings API accepts locales instead of country codes
    // Let's migrate once the back-end is ready
    filters.markets = getDefaultLocaleFromCountry(market)
  }

  if (stock) {
    if (stock === STOCK.WITH_STOCK) {
      filters.has_stock = true
    }

    if (stock === STOCK.WITHOUT_STOCK) {
      filters.quantity = 0
    }
  }

  if (alert && alert === ALERTS.PRICE_OVER_NEW) {
    filters.price_over_new = true
  }

  return filters
}

export async function updateMarketsListingLink({ listing, baseUrl }) {
  const marketLinksPromises = listing.markets.map((market) => {
    return getLink({
      baseUrl,
      link: market.link,
      country: market.countryCode,
    })
  })

  const marketsLinks = await Promise.all(marketLinksPromises)

  return {
    ...listing,
    markets: listing.markets.map((market, index) => {
      return {
        ...market,
        formattedListingLink: marketsLinks[index]?.href,
      }
    }),
  }
}
